import React, { useContext } from "react";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import GlobalContext from "../GlobalContext";
import { ResearchType } from "../pages/loginPages/ConsentFormPage";
import HeaderPadding from "./HeaderPadding";
import FooterPadding from "./FooterPadding";

interface Props {
  children: React.ReactNode;
  onLoginRequest: () => void;
}

const LoginGuard: React.FC<Props> = ({ children, onLoginRequest }) => {
  const { t } = useTranslation();
  const context = useContext(GlobalContext);
  const loggedIn =
    context.agreementAccepted &&
    context.wannaParticipate &&
    context.acceptedResearchType !== ResearchType.NONE;

  if (!loggedIn) {
    return (
      <IonContent className="flavoriapage">
        <HeaderPadding />
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>{t("Login Required")}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <p>{t("Please log in to access this feature.")}</p>
            <IonButton expand="block" onClick={onLoginRequest}>
              {t("Login")}
            </IonButton>
          </IonCardContent>
        </IonCard>
        <FooterPadding />
      </IonContent>
    );
  }

  return <>{children}</>;
};

export default LoginGuard;
